/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CapAnchor = {
    CalendarDay: 'CalendarDay',
    RollingFromEntry: 'RollingFromEntry'
} as const;
export type CapAnchor = typeof CapAnchor[keyof typeof CapAnchor];

